import { render } from "./product-personalisation-form.vue?vue&type=template&id=6aecb22f"
import script from "./product-personalisation-form.vue?vue&type=script&lang=js"
export * from "./product-personalisation-form.vue?vue&type=script&lang=js"

import "./product-personalisation-form.vue?vue&type=style&index=0&id=6aecb22f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__